import React from 'react';
import { Section } from './ui/Section';
import { Button } from './ui/Button';
import { XCircle } from 'lucide-react';
const failures = [{
  title: 'Café postcomida',
  desc: 'Arregla 30 minutos y empeora el patrón (más ansiedad/antojo después).'
}, {
  title: '"Como menos"',
  desc: 'Te quedas con hambre y terminas picando.'
}, {
  title: 'Solo ensalada',
  desc: 'Ligera, sí; estable, no (si le falta proteína/energía limpia).'
}, {
  title: '"Quita todos los carbohidratos"',
  desc: 'Al principio parece que ayuda, pero es difícil de sostener y puede disparar ansiedad.'
}, {
  title: 'Snacks "fitness" raros',
  desc: 'Caros, poco apetecibles, cero vida real.'
}];
export function FailingSolutions() {
  const scrollToPricing = () => {
    const pricingSection = document.getElementById('pricing');
    if (pricingSection) {
      pricingSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  };
  return <Section className="bg-white" data-id="element-108">
      <div className="max-w-4xl mx-auto" data-id="element-109">
        <div className="text-center mb-8" data-id="element-110">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2c4a2c] mb-3" data-id="element-111">
            Por qué lo típico falla (aunque "parezca sano")
          </h2>
          <p className="text-lg text-[#5a5a5a]" data-id="element-112">
            No es falta de información. Es que las soluciones comunes no están
            diseñadas para la franja 15:00–21:00.
          </p>
        </div>

        <div className="space-y-3 mb-8" data-id="element-113">
          {failures.map((item, index) => <div key={index} className="flex gap-3 p-4 rounded-lg bg-[#faf8f5] border-l-4 border-[#c45d3a]" data-id="element-114">
              <XCircle className="w-5 h-5 text-[#c45d3a] shrink-0 mt-0.5" data-id="element-115" />
              <div data-id="element-116">
                <h3 className="font-bold text-[#2c4a2c]" data-id="element-117">{item.title}</h3>
                <p className="text-[#5a5a5a] text-sm" data-id="element-118">{item.desc}</p>
              </div>
            </div>)}
        </div>

        <div className="text-center" data-id="element-119">
          <Button variant="outline" size="lg" data-id="element-120">
            Vale, entonces ¿qué hago?
          </Button>
          <div className="mt-3" data-id="element-121">
            <button onClick={scrollToPricing} className="inline-flex items-center justify-center px-6 py-3 text-sm font-medium text-white bg-[#c45d3a] rounded-full shadow-md hover:bg-[#a84a2a] hover:shadow-lg cursor-pointer transition-all active:scale-95 hover:scale-[1.02]" data-id="element-122">
              Aquí no hay magia: hay método.
            </button>
          </div>
        </div>
      </div>
    </Section>;
}